import React, { useState, useEffect, memo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import PeopleIcon from '@material-ui/icons/People';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { Profile, SidebarNav } from './components';
import { logout } from '../../../../../services/AuthApi';
import { getPerfilUsuario } from '../../../../../services/UserApi';

// Papel retornado em perfil_usuario.papeis quando o usuário lidera algum grupo J1
const PAPEL_LIDER_J1 = 'lider_j1';

const useStyles = makeStyles(theme => ({
    drawer: {
        width: 240,
        [theme.breakpoints.up('md')]: {
            marginTop: 64,
            height: 'calc(100% - 64px)',
        },
    },
    root: {
        backgroundColor: theme.palette.white,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2),
    },
    divider: {
        margin: theme.spacing(2, 0),
    },
    nav: {
        marginBottom: theme.spacing(2),
    },
}));

const Sidebar = props => {
    const { open, variant, onClose, className, ...rest } = props;

    const [usuario, setUsuario] = useState({
        nome: '',
        idIgreja: '',
        txFotoUrl: '',
        papeis: [],
    });
    const [currentPage, setCurrentPage] = useState('Controle Palavra Fest');

    const history = useHistory();

    const classes = useStyles();

    const pageGrupos = {
        title: 'Grupos',
        icon: <PeopleIcon />,
        handleClick: () => {
            setCurrentPage('Grupos');
            history.push('/grupos');
            onClose();
        },
    };

    const pageFrequencia = {
        title: 'Frequência',
        icon: <PlaylistAddCheckIcon />,
        href: '/frequencia',
        handleClick: () => {
            setCurrentPage('Frequência');
            onClose();
            history.push('/frequencia');
        },
    };

    const pageDesafio = {
        title: 'Desafio',
        icon: <PeopleIcon />,
        handleClick: () => {
            history.push('/desafio');
        },
    };

    const pageBibliaOn = {
        title: 'Bíblia On',
        icon: <PeopleIcon />,
        href: '/biblia_on',
        handleClick: () => {
            history.push('/biblia_on');
        },
    };

    const pageVerdeAmarelo = {
        title: 'Dia Verde e Amarelo',
        icon: <PeopleIcon />,
        href: '/evento',
        handleClick: () => {
            history.push('/evento');
        },
    };

    const pagePalavraFest = {
        title: 'Controle Palavra Fest',
        icon: <PeopleIcon />,
        href: '/controle_palavra_fest',
        handleClick: () => {
            setCurrentPage('Controle Palavra Fest');
            onClose();
            history.push('/controle_palavra_fest');
        },
    };

    const pageFaltasJ1 = {
        title: 'Controle de Faltas J1',
        icon: <PlaylistAddCheckIcon />,
        href: '/faltas_j1',
        handleClick: () => {
            setCurrentPage('Controle de Faltas J1');
            onClose();
            history.push('/faltas_j1');
        },
    };

    const pageLogin = {
        title: 'Sair',
        icon: <ExitToAppIcon />,
        handleClick: () => {
            logout();

            history.push('/login');
            history.go();
        },
    };

    const [pages, setPages] = useState([pageGrupos, pageLogin]);

    async function fetchPerfilUsuario() {
        try {
            const perfil = await (await getPerfilUsuario()).data;
            setUsuario(perfil);
        } catch (error) {
            console.error(error);
        }
    }

    function configMenu() {
        //setPages([pageGrupos, pageFrequencia, pagePalavraFest, pageLogin]);
        const paginas = [pageGrupos];

        const papeis = usuario.papeis || [];

        if (papeis.includes(PAPEL_LIDER_J1)) {
            paginas.push(pageFaltasJ1);
        }

        paginas.push(pageLogin);

        setPages(paginas);
    }

    useEffect(() => {
        fetchPerfilUsuario();
    }, []);

    useEffect(() => {
        configMenu();
    }, [usuario]);

    return (
        <Drawer
            anchor="left"
            classes={{ paper: classes.drawer }}
            onClose={onClose}
            open={open}
            variant={variant}
        >
            <div {...rest} className={clsx(classes.root, className)}>
                <Profile usuario={usuario} />
                <Divider className={classes.divider} />
                <SidebarNav
                    className={classes.nav}
                    pages={pages}
                    currentPage={currentPage}
                />
            </div>
        </Drawer>
    );
};

Sidebar.propTypes = {
    className: PropTypes.string,
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    variant: PropTypes.string.isRequired,
};

export default memo(Sidebar);
